export default {
    methods: {
        scrollTo(targetId) {
            const targetEl = document.getElementById(targetId);

            if (targetEl) {
                targetEl.scrollIntoView({behavior: 'smooth', block: 'center'})
            }
        }
    }
}